export default "__VITE_ASSET__DprIRupN__"